import { render, staticRenderFns } from "./RoleCreateDialog.vue?vue&type=template&id=0932d594&scoped=true"
import script from "./RoleCreateDialog.vue?vue&type=script&lang=js"
export * from "./RoleCreateDialog.vue?vue&type=script&lang=js"
import style0 from "./RoleCreateDialog.vue?vue&type=style&index=0&id=0932d594&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0932d594",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0932d594')) {
      api.createRecord('0932d594', component.options)
    } else {
      api.reload('0932d594', component.options)
    }
    module.hot.accept("./RoleCreateDialog.vue?vue&type=template&id=0932d594&scoped=true", function () {
      api.rerender('0932d594', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/roleApi/RoleCreateDialog.vue"
export default component.exports